/**
 * Data API — same exported signatures as the Firestore version, now thin
 * wrappers over the nailor-plus server (which enforces auth, allowlist,
 * and column-explicit upserts).
 */
import type { Model, ModelNote, ModelTemplate } from "nailor-plus-shared";
import { api } from "@/api/client";

// --- models ----------------------------------------------------------------

export const listModels = async (): Promise<Record<string, Model>> =>
  api<Record<string, Model>>("/api/models");

interface SaveModelInput {
  model: Model;
}

// updatedBy is no longer a parameter — the server stamps it from the session.
export const saveModel = async ({ model }: SaveModelInput): Promise<void> => {
  await api<undefined>(`/api/models/${encodeURIComponent(model.model)}`, {
    method: "PUT",
    body: model,
  });
};

// --- model_templates -------------------------------------------------------

export const listModelTemplates = async (): Promise<Record<string, ModelTemplate>> =>
  api<Record<string, ModelTemplate>>("/api/model-templates");

interface SaveTemplateInput {
  template: ModelTemplate;
}

export const saveModelTemplate = async ({ template }: SaveTemplateInput): Promise<void> => {
  await api<undefined>(`/api/model-templates/${encodeURIComponent(template.series_id)}`, {
    method: "PUT",
    body: template,
  });
};

// --- accessory_photos_baseline ---------------------------------------------

export const listAccessoryPhotosBaseline = async (): Promise<Record<string, string>> =>
  api<Record<string, string>>("/api/accessory-photos-baseline");

// --- model_notes -----------------------------------------------------------

export const listNotesForModel = async (modelCode: string): Promise<ModelNote[]> =>
  api<ModelNote[]>(`/api/model-notes?modelCode=${encodeURIComponent(modelCode)}`);

interface AddNoteInput {
  modelCode: string;
  text: string;
}

export const addNote = async ({ modelCode, text }: AddNoteInput): Promise<void> => {
  await api<{ id: number }>("/api/model-notes", { body: { modelCode, text } });
};

export const deleteNote = async (id: number): Promise<void> => {
  await api<undefined>(`/api/model-notes/${id}`, { method: "DELETE" });
};
